import React, { useState } from 'react';
import { Form, Button, Container, Row, Col, Alert } from 'react-bootstrap';

function StudentRegistration({ setStudentView }) {
    const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    password: '',
  });

  const [message, setMessage] = useState('');
  const [successMsg, setSuccessMsg] = useState("");

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setSuccessMsg("");
    setMessage("");

    try {
      const response = await fetch("/api/register", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          name: form.name,
          email: form.email,
          password: form.password,
          phone: form.phone,
        })
      });

      const data = await response.json();

      if (response.ok) {
        setSuccessMsg("You are registered! Please Login to complete your profile and fill application form.");
        setMessage(""); // Clear error
        setForm({
          name: '',
          email: '',
          phone: '',
          password: '',
        });
      } else {
        setMessage(data.message || "Registration failed.");
        setSuccessMsg("");
      }
    } catch (err) {
      setMessage("Something went wrong. Please try again.");
      setSuccessMsg("");
      console.error(err);
    }
  }

  return (
    <Container className="mt-5">
      <Row className="justify-content-md-center">
        <Col xs={12} md={8} lg={6}>
          <h1
            className="mb-4 text-center"
            style={{
              fontSize: "2.5rem",
              fontWeight: "bold",
              color: "#ffffffff",
              letterSpacing: "1px",
              textShadow: "0 4px 14px rgba(42, 82, 152, 0.12)"
            }}
          >
            STUDENT REGISTRATION
          </h1>
          {successMsg && (
            <Alert variant="success" className="text-center">
              {successMsg}
            </Alert>
          )}

          <Form onSubmit={handleSubmit} className="p-4 rounded shadow bg-white">
            <Form.Group className="mb-3" controlId="formName">
              <Form.Label>Name*</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                required
                placeholder="Enter your full name"
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formEmail">
              <Form.Label>Email*</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                required
                placeholder="Enter your email address"
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formPhone">
              <Form.Label>Phone Number*</Form.Label>
              <Form.Control
                type="tel"
                name="phone"
                value={form.phone}
                onChange={handleChange}
                required
                placeholder="Enter your phone number"
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formPassword">
              <Form.Label>Password*</Form.Label>
              <Form.Control
                type="password"
                name="password"
                value={form.password}
                onChange={handleChange}
                required
                placeholder="Create a password"
              />
            </Form.Group>
            <div className="text-center mb-3">
              <span style={{ color: "red", fontWeight: "bold", fontSize: "1rem" }}>
                Please fill out admission form in your profile after login.
              </span>
            </div>
            <div className="d-grid">
              <Button variant="primary" type="submit">
                Register
              </Button>
            </div>
         

{/* Centered "Already have an account? Login" button */}
<div className="text-center mt-3">
  <Button
    variant="link"
    onClick={() => setStudentView && setStudentView("login")}
    style={{
      color: "#6a1b9a",
      fontWeight: 500,
      fontSize: "1.1rem",
      textAlign: "center"
    }}
  >
    Already have an account? Login
  </Button>
</div>

          </Form>
          {message && (
            <Alert
              variant={
                message.toLowerCase().includes("fail") ||
                message.toLowerCase().includes("must be at least") ||
                message.toLowerCase().includes("already") ||
                message.toLowerCase().includes("wrong") ||
                message.toLowerCase().includes("error")
                  ? "danger"
                  : "success"
              }
              className="mt-3 text-center"
            >
              {message}
            </Alert>
          )}
        </Col>
      </Row>
    </Container>
  );
}

export default StudentRegistration;
